import type { FC } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';

import LoginPageDesktop from './LoginPageDesktop';
import LoginPageMobile from './LoginPageMobile';

const LoginPage: FC = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'), { noSsr: true });

  return isDesktop ? <LoginPageDesktop /> : <LoginPageMobile />;
};

export default LoginPage;
